import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective {

  @Input() public appAutoFocus: boolean;

  constructor(private el: ElementRef) { }

  public ngAfterContentInit() {

    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 150);

  }

}
